<template>
  <div class="footer-wrapper">
    <div class="imprint-links">
      <img class="logo_sf" src="../../assets/icons/sf_logo.png" alt="close" />
      <a target="_blank" href="https://www.schubert-franzke.com">
        &copy; Schubert &amp; Franzke
      </a>

      <a target="_blank" href="https://www.schubert-franzke.com/m2wimpressum/">
        {{ $t("settings.dataPrivacy") }}
      </a>

      <router-link v-if="hasBasemap" to="/legend">
        {{ $t("settings.legend") }}
      </router-link>
    </div>

    <!-- <div class="pnrr-info">
      <div class="pnrr-disclaimer">
        „Conținutul acestui material nu reprezintă în mod obligatoriu poziția oficială a Uniunii Europene sau a
        Guvernului României”.
      </div>

      <div class="pnrr-line">
        <span class="line-blue"></span>
        <span class="line-yellow"></span>
        <span class="line-red"></span>
      </div>

      <div class="pnrr-title">
        „PNRR. Finanțat de Uniunea Europeană - UrmătoareaGenerațieUE“
      </div>

      <div class="pnrr-contact">
        <a target="_blank" href="https://mfe.gov.ro/pnrr/">
          Website - https://mfe.gov.ro/pnrr/
        </a>

        <a target="_blank" href="https://www.facebook.com/PNRROficial">
          Facebook - https://www.facebook.com/PNRROficial
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ImprintLinks",

  data() {
    return {
      hasBasemap: !!Vue.config.project.sf_basemap
    };
  }
};
</script>

<style scoped lang="scss">
.logo_sf {
  width: 25px;
  height: 20px;
}
.footer-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 40001;
}

.imprint-links {
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.9);
}

.imprint-links > a {
  font-size: 10px;
  text-decoration: none;
  color: #464646;

  &::after {
    padding: 0 10px;
    content: "|";
  }

  &:last-child::after {
    padding: 0;
    content: "";
  }
}

.pnrr-info {
  width: 100%;
  box-sizing: border-box;
  background: #e0e0e0;
  // background: rgba(255, 255, 255, 0.95);
  padding: 4px 30px 6px;
  color: #003b7a;
  font-family: Arial, sans-serif;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.12);
}

.pnrr-disclaimer {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
}

.pnrr-line {
  width: 100%;
  height: 3px;
  display: flex;
  margin-bottom: 6px;
}

.pnrr-line span {
  flex: 1;
}

.line-blue {
  background: #0050a4;
}

.line-yellow {
  background: #fcd116;
}

.line-red {
  background: #ce1126;
}

.pnrr-title {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
}

.pnrr-contact {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
}

.pnrr-contact a {
  color: #003b7a;
  font-size: 10px;
  font-weight: 600;
  text-decoration: underline;
}

// @media (max-width: 768px) {
//   .pnrr-info {
//     padding: 4px 8px;
//   }

//   .pnrr-disclaimer {
//     font-size: 8px;
//   }

//   .pnrr-title {
//     font-size: 10px;
//   }

//   .pnrr-contact {
//     gap: 8px;
//     flex-wrap: wrap;
//   }

//   .pnrr-contact a {
//     font-size: 8px;
//   }
// }
@media (max-width: 768px) {
  .pnrr-info {
    padding: 3px 8px;
  }

  .pnrr-disclaimer {
    font-size: 8px;
    line-height: 1.3;
    margin-bottom: 2px;
  }

  .pnrr-line {
    height: 3px;
    margin-bottom: 3px;
  }

  .pnrr-title {
    font-size: 10px;
    line-height: 1.3;
    margin-bottom: 2px;
  }

  .pnrr-contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.2px;
  }

  .pnrr-contact a {
    font-size: 8px;
    line-height: 1.3;
    margin: 0;
    padding: 0;
  }
}
</style>
